import styled from 'styled-components';
import { colors } from '../../../../theme/style-helpers';

const Container = styled.a`
    font-weight: 600;
    font-size: 14px;
    line-height: 150%;
    letter-spacing: 0.01em;
    color: ${colors.BLACK};
    margin: 0;
    display: inline;
    text-decoration: underline;
    text-underline-offset: 2px;

    &:hover, &:focus {
        text-decoration-color: #FF5F14;
        color: ${colors.BLACK};
    }

    &:focus {
        background-color: #FF5F141A;
        text-decoration-color: #FF5F14;
        outline: none;
        padding: 0 4px;
    }
`;

export default Container;
